@if (errorMessage !== '') {
  <app-alert [type]="'error'" [message]="errorMessage" [dismissible]="true" (dismiss)="errorMessage = ''"></app-alert>
}
<div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-12 gap-4 mt-4">

  <div class="col-span-12 md:col-span-4 lg:col-span-3 bg-surface-muted p-2 rounded-lg shadow h-fit">
    <div class="flex flex-wrap gap-2 justify-between">
      <h2 class="text-xs 2xl:text-sm">{{category?.name}} ({{instanceNumber}})</h2>
      <div class="flex flex-row gap-2">
        <button class="bg-white items-center w-6 h-6" (click)="sortByDateOrName(!sortAscending)">
          <app-icon-sort [sortAscending]="sortAscending" style="width: 25px;"></app-icon-sort>
        </button>
        <button class="bg-white items-center relative filter-menu-open w-6 h-6" (click)="toggleDropdown()">
          <img src="../../../assets/Sorting.png" />
          @if (filterInstanceMenuOpen) {
            <div
              class="absolute right-0 mt-2 w-32 bg-white border-none rounded-sm shadow-md z-20 text-sm">
              @for (type of searchTypes; track type) {
                <div class="flex items-center px-3 py-2 cursor-pointer gap-2"
                  (click)="setSearchType(type.value)">
                  <span class="w-4 text-black mr-2">
                    @if (searchType === type.value) {
                      <app-icon-check></app-icon-check>
                    }
                  </span>
                  {{ type.label }}
                </div>
              }
            </div>
          }
        </button>
        <button *appAgentWritable class="w-6 h-6 flex items-center  bg-white  text-xl font-bold" (click)="openModal(3)">
          <app-icon-plus class="size-6"></app-icon-plus>
        </button>
      </div>
    </div>

    <ul class="mt-2 bg-white border-2 rounded-xl flex-wrap gap-2">
      <div class="p-2">
        <input type="text" [placeholder]="'INSTANCE.SEARCH_PLACEHOLDER' | translate" [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchChange()"
          class="w-full pl-8 pr-8 py-2 bg-surface-muted focus:outline-none focus:ring-0 focus:border-none text-xs 2xl:text-sm placeholder:text-black" />
      </div>
      @if (showInstance) {
        <div class="w-full flex justify-center m-2">
          <div role="status">
            <app-loading-spinner></app-loading-spinner>
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      }
      <div class="flex justify-between items-center m-2">
        @if (instances && instances.length > 0) {
          <div class="flex items-center">
            <input id="selectAll" type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelection($event)"
              class="appearance-none h-3 w-3 border border-gray-400 rounded-sm checked:bg-amber-800 checked:border-amber-800 relative cursor-pointer" />
            <label for="selectAll" class="text-amber-800 cursor-pointer ml-2">{{"INSTANCE.SELECT_ALL" |
            translate}}</label>
          </div>
        }
        <div class="flex-grow"></div>
        <div class="flex gap-2">
          @if (selectedIds.length > 0) {
            <button *appAgentWritable class="flex items-center bg-surface-muted rounded-md shadow-md border-2 p-1"
              (click)="openModal(4)">
              <app-icon-trash class="h-4 w-4"></app-icon-trash>
            </button>
            <button class="flex items-center bg-surface-muted rounded-md shadow-md border-2 p-1" (click)="exportInstances()"
              title="Exporter">
              @if (exporting) {
                <app-loading-spinner class="w-5 h-5"></app-loading-spinner>
                }@else {
                <img src="../../../assets/exportation.png" class="h-4 w-4" alt="Import icon" />
              }
            </button>
          }
          <button *appAgentWritable class="flex items-center bg-surface-muted rounded-md shadow-md border-2 p-1"
            (click)="openModal(5)" title="Importer">
            <img src="../../../assets/importer.png" class="h-4 w-4" alt="Export icon" />
          </button>
        </div>
      </div>
      @for (inst of instances; track $index) {
        <div (click)="selectInstance(inst)" [class]="inst.id === instance?.id ? 'bg-surface-muted' : ''"
          class="p-2 text-sm cursor-pointer flex flex-col border-b border-b-gray-200">
          <div class="flex justify-between items-center leading-none">
            <div class="flex flex-row items-center gap-2">
              <input type="checkbox" [checked]="isSelected(inst.id)" (change)="toggleSelection(inst.id)"
                class="appearance-none h-3 w-3 border border-gray-400 rounded-sm checked:bg-amber-800 checked:border-amber-800 relative cursor-pointer" />
              <div class="flex flex-col leading-none">
                <span class="text-xs 2xl:text-sm leading-none">{{ inst.name }}</span>
                <span class="text-xs text-gray-400 leading-none">{{ inst.code }}</span>
              </div>
            </div>
            <app-dropdown [(optionItems)]="optionItems" (click)="onDropdownClick(inst.id)">
              <app-icon-more-actions *appAgentWritable></app-icon-more-actions>
            </app-dropdown>
          </div>
        </div>
        }@empty {
          @if (!showInstance) {
            <app-empty-state
              [compact]="true"
              [icon]="searchTerm ? 'search' : 'empty'"
              [title]="searchTerm ? 'INSTANCE.NO_RESULTS' : 'INSTANCE.Empty_LIST'"
            ></app-empty-state>
          }
        }
    </ul>
  </div>
  @if (instance) {
    <div class="col-span-12 md:col-span-8 lg:col-span-9 bg-surface-muted p-4 rounded-lg shadow">
      <app-description-list [instance]="instance" [descriptions]="descriptions"
      [showDescription]="showDescription"></app-description-list>
    </div>
  }
</div>
@if (modalValue() === 3) {
  <app-modal>
    <div class="text-lg text-center">
      {{ instance ? ('MODAL.MODIFY_QUESTION' | translate) : ('MODAL.ADD_NEW_ITEM' | translate) + (category?.name || '') }}
    </div>
    <form [formGroup]="instanceForm" (ngSubmit)="saveInstance()" class="space-y-3">
      <app-input
        id="name"
        [label]="'MODAL.NAME' | translate"
        [ariaLabel]="'MODAL.NAME' | translate"
        formControlName="name"
        placeholder="Nom"
        [error]="instanceForm.get('name')?.invalid && instanceForm.get('name')?.touched ? ('MODAL.REQUIRED_NAME' | translate) : null"
        [reserveErrorSpace]="false"
      ></app-input>

      <app-input
        id="code"
        [label]="'MODAL.CODE' | translate"
        [ariaLabel]="'MODAL.CODE' | translate"
        formControlName="code"
        placeholder="Code"
        [error]="instanceForm.get('code')?.invalid && instanceForm.get('code')?.touched ? ('MODAL.REQUIRED_CODE' | translate) : null"
        [reserveErrorSpace]="false"
      ></app-input>

      <div class="flex justify-end space-x-2">
        <app-button variant="outline" type="button" (btnClick)="closeModal()">
          {{ 'MODAL.CANCEL' | translate }}
        </app-button>
        <app-button type="submit" [loading]="isSaving" [disabled]="!instanceForm.valid || isSaving">
          {{ 'MODAL.SUBMIT' | translate }}
        </app-button>
      </div>
    </form>
  </app-modal>
}
@if (modalValue() === 4) {
  <app-modal>
    <div class="flex flex-col items-center text-center">
      <div class="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mb-4">
        <i class="fa-solid fa-xmark text-red-600 text-xl"></i>
      </div>
      <h2 class="text-lg font-semibold text-gray-800">
        {{ 'MODAL.DELETE_CONFIRMATION' | translate }}
      </h2>
      @if(selectedIds.length > 0) {
        <p class="text-sm text-gray-600 mt-3 px-4">
          {{"MODAL.ARE_YOU_SURE_YOU_WANT_TO_DELETE" | translate}}
          <span class="font-semibold">{{ selectedIds.length }}</span> {{"MODAL.ENTITY_SELECTED" | translate}}
          <br />{{"MODAL.DELETE_ALL_ASSOCIATED_DESCRIPTIONS" | translate}}
        </p>
      }
      <div class="flex justify-end space-x-3 mt-6 w-full px-6">
        <app-button variant="outline" type="button" (btnClick)="closeModal()">
          {{ 'MODAL.CANCEL' | translate }}
        </app-button>
        <app-button (btnClick)="deleteInstance()">
          {{ 'MODAL.SUBMIT' | translate }}
        </app-button>
      </div>
    </div>
  </app-modal>

}
@if (modalValue() === 5){
  <app-modal>
    <div class="bg-white">
      <div class="flex justify-between items-center text-center p-4 bg-surface-muted">
        <span class="text-xl font-bold">{{ 'MODAL.IMPORT.IMPORT_TITLE' | translate }}</span>
        <button (click)="closeModal()"><img src="../../../assets/delete-circled.png" alt="delete circled"
        class="h-6 w-6" /></button>
      </div>
      <div class="bg-white justify-center items-center">
        @if (!fileName()) {
          <div
            class="border-2 border-gray-400 border-dashed rounded-md cursor-pointer justify-center items-center m-4">
            <span class="flex justify-center p-2">
              <img src="../../../../assets/importer.png" alt="upload" class="h-6 w-6" />
            </span>
            <div class="block w-full text-center cursor-pointer p-2" (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" (click)="fileInputNinea.click()">
              <p [innerHTML]="'MODAL.IMPORT.DRAG_DROP' | translate"></p>
              <p>{{ 'MODAL.IMPORT.ACCEPTED_FORMAT' | translate }}</p>
              <input type="file" id="file" #fileInputNinea accept=".json" (change)="handleFileInput($event)"
                class="hidden" />
            </div>
          </div>
        }
        @if (fileName()) {
          <div class="border-2 rounded-md border-blue-300 p-2 m-2">
            <div class="flex justify-between items-center p-2">
              <div class="flex items-center gap-4">
                <div class="relative w-10 h-10 bg-white border border-gray-300 rounded shadow-md">
                  <div class="absolute top-0 right-0 w-3 h-3 bg-green-500 clip-triangle rounded-md"></div>
                  <div class="absolute inset-0 flex items-center justify-center">
                    <span class="bg-green-600 text-white font-bold text-xs rounded shadow">
                      .{{fileExtention}}
                    </span>
                  </div>
                </div>
                <div class="text-sm text-gray-800 font-medium">
                  {{ fileName() }}
                </div>
              </div>
              <div class="text-sm text-secondary-600">
                {{uploadProgress}}%
              </div>
            </div>
            <div class="bg-primary-800 p-2 rounded-full transition-all" [style.width.%]="uploadProgress"></div>
          </div>
        }
        <div class="flex justify-end items-center text-center p-4 bg-surface-muted">
          <app-button (btnClick)="closeModal()">{{ 'MODAL.IMPORT.CLOSE' | translate }}</app-button>
        </div>
      </div>
    </div>
  </app-modal>
}